// extracted by mini-css-extract-plugin
export default {"promotionPop":"promotionCongrats_promotionPop__YMRsw","price":"promotionCongrats_price__fslzg"};